module.exports = __webpack_public_path__ + "img/main.f4bb6e6d.png";